













import { Component, Mixins } from "vue-property-decorator";
import MultiOptionListBoxSelector from "../../system/selectors/MultiOptionListBoxSelector.vue";
import { ProfessionsSelectableMixin } from "./mixins";
import { FixedLoading } from "../../system";

@Component({
  components: {
    MultiOptionListBoxSelector,
    FixedLoading,
  },
})
export default class MultiProfessionListSelector extends Mixins(ProfessionsSelectableMixin) {
}
